import React from "react";

const ChevronDown = ({ size = 14, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const Dropdown = ({
  ref,
  isOpen,
  setIsOpen,
  trigger,
  children,
  dropdownClassName = "",
  buttonClassName = "",
  containerClassName ="",
  type="button"
}) => {
  return (
    <div className={` relative flex-shrink-0 ${containerClassName}`} ref={ref}>
      <button
        type={type}
        onClick={setIsOpen}
        className={buttonClassName}
      >
        {trigger}
        <ChevronDown
          className={`transition-transform mt-1 duration-200 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>
      {isOpen && (
        <div className={`absolute top-full left-0 mt-2 bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 rounded-2xl shadow-xl z-50 ${dropdownClassName}`}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Dropdown;

